import { useEffect, useState, useRef } from 'react';

import debounce from 'lodash/debounce';

export function useOnScrollUp(offset = 0) {
  const prevScrollY = useRef(0);
  const ticking = useRef(false);

  const [hasScrolledUp, setHasScrolledUp] = useState(false);

  function handleScroll() {
    const isUp = window.scrollY < prevScrollY.current;
    const isBelowHeader = window.scrollY > offset;

    setHasScrolledUp(isUp && isBelowHeader);
    prevScrollY.current = window.scrollY;
    ticking.current = false;
  }

  const debouncedHandleScroll = debounce(handleScroll, 300);

  function onScroll() {
    if (!ticking.current) {
      window.requestAnimationFrame(debouncedHandleScroll);
      ticking.current = true;
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      debouncedHandleScroll.cancel();
    };
  }, []);

  return { hasScrolledUp };
}
